<template>
  <div>
    <form @submit.prevent>
      <base-input alternative="" :label="$t('language')" required>
        <v-select
          :placeholder="$t('language')"
          class="form-control-alternative border bg-white p-2 rounded mt-2"
          v-model="lang"
          data-vv-validate-on="blur"
          v-validate="'required'"
          :data-vv-as="$t('language')"
          name="lang"
          :options="options"
          autocomplete="off"
        />
        <span class="text-danger text-sm" v-show="errors.has('lang')"
          ><small>{{ errors.first("lang") }}</small></span
        >
      </base-input>
      <div v-if="valid">
        <hr />
        <label
          ><strong>{{ $t("conditions") }}</strong
          ><span class="text-danger">*</span></label
        >
        <markdown-editor
          toolbar=" bold italic strikethrough heading image link | numlist bullist code quote preview fullscreen"
          height="auto"
          theme="primary"
          v-model="form.content"
          :options="optiones"
        ></markdown-editor>
        <hr />
      </div>
      <div class="d-flex justify-content-end">
        <base-button type="primary" class="my-4" @click="add">{{
          $t("save")
        }}</base-button>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  props: {
    company: {
      type: String | Number,
    },
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.getTermConditions, 500);
    const language = localStorage.getItem("lang");
    if (language) {
      language === "es"
        ? (this.lang = this.options[1])
        : language === "en"
        ? (this.lang = this.options[0])
        : language === "de"
        ? (this.lang = this.options[2])
        : "";
    }
  },
  watch: {
    lang: function (newQuestion, oldQuestion) {
      this.valid = false;
      this.debouncedGetAnswer();
    },
    terms() {
      if (this.terms) {
        this.form = {
          id: this.terms.id,
          content: this.terms.content,
        };
        this.valid = true;
      } else {
        this.form = {
          id: "",
          content: ""
        };
      }
    },
  },
  data() {
    return {
      form: {
        id: "",
        content: "",
      },
      lang: null,
      options: [
        { label: this.$t("english"), value: "en" },
        { label: this.$t("spanish"), value: "es" },
        { label: this.$t("germany"), value: "de" },
      ],
      valid: false,
      optiones: {
        lineNumbers: true,
        styleActiveLine: true,
        styleSelectedText: true,
        lineWrapping: true,
        indentWithTabs: true,
        tabSize: 2,
        indentUnit: 2,
      },
    };
  },
  methods: {
    ...mapActions({
      createConditions: "conditions/createOrUpdate",
      getTermsAndConditions: "conditions/getTerms",
    }),

    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          const payload = {
            id: this.form.id,
            lang: this.lang.value,
            content: this.form.content,
            company: this.$route.params.id ? this.$route.params.id : "",
          };
          const res = await this.createConditions(payload);
          await this.getTermConditions();
          this.$toast.success(res.message, {
            position: "top-right",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTermConditions() {
      try {
        await this.getTermsAndConditions({
          language: this.lang.value,
          company: this.company,
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.valid = true;
      }
    },
  },
  computed: {
    ...mapGetters({
      terms: "conditions/terms",
    }),
  },
};
</script>
<style>
.vs__dropdown-toggle {
  border: none;
}
.vs__search {
  color: rgb(189, 189, 189);
}
.vti__input::-webkit-input-placeholder {
  color: rgb(189, 189, 189) !important;
}
.vs__selected {
  color: #707070 !important;
}
</style>

 